module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"pv_by_source":{"singlemessage":"朋友转发","timeline":"朋友圈","groupmessage":"群转发","other":"其他","course":"课程中心","knowledge":"资料中心","total":"总计"},"shares_by_target":{"sendappmessage":"微信好友","sharetimeline":"朋友圈","shareqq":"QQ好友","other":"其他"}}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/project/stats/summary.view.vue
// module id = 342
// module chunks = 3